import React, { useMemo, useState } from "react";
import "./ContractsModal.css";

function onlyDigits(s) { return String(s ?? "").replace(/\D+/g, ""); }
function formatIIN(v) {
  const d = onlyDigits(v);
  if (!d) return "—";
  if (d.length === 12) return `${d.slice(0,6)} ${d.slice(6,7)}${d.slice(7,11)} ${d.slice(11)}`;
  return d;
}
function formatPhone(v) {
  const d = onlyDigits(v);
  if (!d) return "—";
  if (d.length === 11 && d.startsWith("7")) {
    return `+7 ${d.slice(1,4)} ${d.slice(4,7)}-${d.slice(7,9)}-${d.slice(9)}`;
  }
  if (d.length === 10) {
    return `+7 ${d.slice(0,3)} ${d.slice(3,6)}-${d.slice(6,8)}-${d.slice(8)}`;
  }
  return `+${d}`;
}
function escapeReg(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }
function highlight(text, q) {
  const t = String(text ?? "");
  const qq = String(q ?? "").trim();
  if (!qq) return t;
  const re = new RegExp(escapeReg(qq), "ig");
  const parts = t.split(re);
  const matches = t.match(re) || [];
  const out = [];
  for (let i = 0; i < parts.length; i++) {
    out.push(parts[i]);
    if (i < matches.length) out.push(<mark key={i} style={{ padding: 0 }}>{matches[i]}</mark>);
  }
  return out;
}

export default function ContractsModal({
  locale = "kz",
  contractList = [],
  orderId,
  onClose,
  onCreate = () => {},
}) {
  const t = useMemo(
    () => ({
      kz: {
        title: "Сыртқы сарапшылар",
        search: "Іздеу (аты/эл. пошта)",
        name: "Аты-жөні",
        email: "Эл. пошта",
        iin: "ЖСН",
        phone: "Телефон",
        position: "Лауазымы",
        apps: "Өтінімдер",
        close: "Жабу",
        empty: "Сарапшылар табылмады",
        total: (n) => `Барлығы: ${n}`,
        create: "Келісімшарт жасау",
      },
      ru: {
        title: "Внешние эксперты",
        search: "Поиск (ФИО/e-mail)",
        name: "ФИО",
        email: "E-mail",
        iin: "ИИН",
        phone: "Телефон",
        position: "Должность",
        apps: "Заявки",
        close: "Закрыть",
        empty: "Экспертов не найдено",
        total: (n) => `Всего: ${n}`,
        create: "Создать договор",
      },
    }[locale]),
    [locale]
  );

  // helpers сверху файла (добавь)
function getApps(x) {
  if (Array.isArray(x?.applications)) return x.applications;
  const c = Number(x?.applications_count);
  if (Number.isFinite(c)) return Array(c).fill(null);
  return [];
}
function appsTooltip(apps) {
  // для title в ячейке — по строке на заявку
  return apps.filter(Boolean).map(a => String(a?.title ?? "").trim()).filter(Boolean).join("\n");
}


  const [q, setQ] = useState("");
  const [selectedId, setSelectedId] = useState(null);

// фильтрация (замени блок useMemo(filtered) целиком)
const filtered = useMemo(() => {
  const qq = q.trim().toLowerCase();
  if (!qq) return contractList;
  return contractList.filter((x) => {
    const name = String(x?.name || "").toLowerCase();
    const email = String(x?.email || "").toLowerCase();
    const apps = getApps(x);
    // ищем и по названиям заявок
    const inApps = apps.some(a =>
      String(a?.title || "").toLowerCase().includes(qq)
    );
    return name.includes(qq) || email.includes(qq) || inApps;
  });
}, [q, contractList]);


  const selectedExpert = (contractList || []).find((x) => x?.id === selectedId) || null;

  return (
    <div className="cm-backdrop" onClick={onClose}>
      <div className="cm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cm-header">
          <div className="cm-title">
            {t.title} {orderId ? `#${orderId}` : ""}
          </div>
          <button className="cm-close" onClick={onClose}>×</button>
        </div>

        <div className="cm-toolbar">
          <input
            className="cm-input"
            placeholder={t.search}
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
          <div className="cm-total">{t.total(filtered.length)}</div>
        </div>

        <div className="cm-table-wrap">
          <table className="cm-table">
            <thead>
  <tr>
    <th style={{ width: 28 }} />
    <th>{t.name}</th>
    <th>{t.email}</th>
    <th>{t.iin}</th>
    <th>{t.phone}</th>
    <th>{t.position}</th>
    <th style={{ width: 90 }}>{t.apps}</th>
  </tr>
</thead>
            <tbody>
  {filtered.length === 0 ? (
    <tr><td colSpan={7} className="cm-empty">{t.empty}</td></tr>
  ) : (
    filtered.map((x) => {
      const apps = getApps(x);
      const appsCount = apps.length;
      const titles = appsTooltip(apps);

      return (
        <tr
          key={x.id}
          onClick={() => setSelectedId(x.id)}
          className={selectedId === x.id ? "cm-row-selected" : ""}
        >
          <td>
            <input
              type="radio"
              name="exp"
              checked={selectedId === x.id}
              onChange={() => setSelectedId(x.id)}
              onClick={(e) => e.stopPropagation()}
            />
          </td>
          <td>{highlight(x.name, q)}</td>
          <td>{x.email || "—"}</td>
          <td>{formatIIN(x.iin)}</td>
          <td>{formatPhone(x.phone)}</td>
          <td>{x.position || "—"}</td>

          {/* НОВАЯ ПРАВИЛЬНАЯ ЯЧЕЙКА "Заявки" */}
          <td title={titles || ""} className="cm-apps-cell">
            {appsCount > 0 ? <span className="cm-badge">{appsCount}</span> : "—"}
          </td>
        </tr>
      );
    })
  )}
</tbody>

          </table>
        </div>

       {/* заявки выбранного эксперта */}
 {Array.isArray(selectedExpert?.applications) && selectedExpert.applications.length > 0 && (
   <div className="cm-applications">
     <h4>{t.apps}:</h4>
     <ul>
       {selectedExpert.applications.map((a) => (
         <li key={a.id}>{a.title}</li>
       ))}
     </ul>
   </div>
 )}

        <div className="cm-footer">
          <button className="cm-btn" onClick={onClose}>{t.close}</button>
<button
   className="cm-btn cm-btn-primary"
   disabled={!selectedExpert}
   onClick={() => {
     if (selectedExpert) {
       onCreate({
         expert: selectedExpert,
         orderId,
         applications: Array.isArray(selectedExpert.applications) ? selectedExpert.applications : [],
       });
     }
   }}
 >
  {t.create}
</button>

        </div>
      </div>
    </div>
  );
}
